module.exports = __webpack_public_path__ + "media/images/registrations/info_version/info-mobile-03-cfb0cea3d7ae77fc6303e95d4a57e694.png";